import { Controller } from "@hotwired/stimulus"

// This controller prevents HTTP form submissions in native app environments
// Native apps only support AJAX form submissions, so HTTP submissions would fail
// This helps catch forms that aren't properly configured for app environments during development
export default class extends Controller {
  connect() {
    // Store event listeners for cleanup
    this.formListeners = new Map()
    this.interceptForms()
  }

  interceptForms() {
    // Find all forms on the page
    const forms = document.querySelectorAll("form")

    forms.forEach((form) => {
      // Skip forms that already have event listeners
      if (form.hasAttribute("data-app-intercepted") || form.method.toUpperCase() === "GET") {
        return
      }

      // Mark form as intercepted to avoid duplicate listeners
      form.setAttribute("data-app-intercepted", "true")

      // Create the submit handler
      const submitHandler = (event) => {
        // Check if this is an AJAX form submission
        const isAjaxForm = form.hasAttribute("data-remote") &&
                          form.getAttribute("data-remote") === "true"

        // If it's not an AJAX form, prevent submission and show alert
        if (!isAjaxForm) {
          event.preventDefault()

          // Show alert to developer/tester
          const actionPath = (form.action && form.action !== window.location.href)
            ? new URL(form.action).pathname
            : "No action specified"

          alert(`
🚨 Native App Form Error 🚨

This form is trying to submit via HTTP, but native apps only support AJAX submissions.

Form details:
- Action: ${actionPath}
- Method: ${form.method.toUpperCase() || "GET"}

To fix this:
1. Add 'data-remote="true"' to the form
2. Ensure the AJAX form is working correctly

This alert only appears when viewing app domains in a browser.
          `.trim())

          console.error("Native app form submission blocked:", {
            form: form,
            action: form.action,
            method: form.method,
            hasDataRemote: form.hasAttribute("data-remote"),
            dataRemoteValue: form.getAttribute("data-remote")
          })
        }
      }

      // Store the handler reference for cleanup
      this.formListeners.set(form, submitHandler)

      // Add the event listener
      form.addEventListener("submit", submitHandler)
    })
  }

  // Called when controller disconnects
  disconnect() {
    // Remove event listeners and clean up intercepted forms
    if (this.formListeners) {
      this.formListeners.forEach((handler, form) => {
        form.removeEventListener("submit", handler)
        form.removeAttribute("data-app-intercepted")
      })
      this.formListeners.clear()
    }
  }
}